import { useEffect, useRef, useState } from "react";
import { Link, useOutletContext } from "react-router-dom";
import TopbarSearch from "../Sidebar/TopbarSearch";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../context/AuthContext";

function DashboardHeader({ children }) {
  const [sidebarToggle] = useOutletContext();
  const [showDropdown, setShowDropdown] = useState(false);
  const plusRef = useRef(null);
  const dropdownRef = useRef(null);

  // Hide dropdown when clicking outside
  useEffect(() => {
    if (!showDropdown) return;
    const handleClickOutside = (event) => {
      if (plusRef.current && plusRef.current.contains(event.target)) {
        return;
      }
      if (dropdownRef.current && dropdownRef.current.contains(event.target)) {
        return;
      }
      setShowDropdown(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showDropdown]);
  const [scButton, setScButton] = useState(false);
  const search = useRef("");
  const { t } = useTranslation();
  // Language selection (UI currently commented out). Re-add if enabling language switcher.

  const handleChange = (e) => {
  };

  const clearSearch = () => {
    search.current.value = "";
    setScButton(false);
  };


  const { user } = useAuth();

  const avatar =
    user?.image ||
    process.env.REACT_APP_DEFAULT_AVATAR ||
    "https://via.placeholder.com/48";

  return (
    <div className=" px-3 sm:px-8 py-3 flex items-center w-full justify-between border-b border-gray-200 dark:border-dark-border bg-white dark:bg-dark-bg sticky top-0 z-[100] relative">
      {children}
      <div className="flex flex-row gap-3">
        <Link
          to={`/profile`}
          className="flex-shrink-0 rounded-full block border dark:border-dark-border shadow-lg"
        >
          <img
            className="rounded-full md:h-10 md:w-10 h-8 w-8 border dark:border-dark-border cursor-pointer object-cover"
            src={avatar}
            alt="Avatar"
          />
        </Link>
      </div>
    </div>
  );
}

export default DashboardHeader;
